import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { Area } from '../../../../../../core/constants/area';
import { EditServiceSubscriptionRequest } from '../../../../models/requests';

@Injectable()
export class ServiceSubscriptionService {

  constructor(public httpClient: HttpClient) { }

  getList(activeOnly:boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/List?activeOnly=${activeOnly}`;
    return this.httpClient.get<any[]>(url);
  }
  getCompanyList(companyId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Company/List?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }
  getRateList(subscriptionId: number, companyIds: number[]) {
    const companyIdString = companyIds.join(',');
    let url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/List?subscriptionId=${subscriptionId}`;
    companyIds.forEach(companyId =>{
      url += `&companyIds=${companyId}`
    })
    return this.httpClient.get<any[]>(url);
  }
  getCompanyRateList(companyId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/rate/Company/List?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }
  getFrequencyDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/frequency/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  patchArchiveSubscription(subscriptionId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Archive/Company?companySubscriptionId=${subscriptionId}`;
    return this.httpClient.patch<any[]>(url, {});
  }
  patchOverrideSubscription(subscriptionId: number, override: boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Override?companySubscriptionId=${subscriptionId}&isOverride=${override}`;
    return this.httpClient.patch<any[]>(url, {});
  }
  setSubscriptionBatch(batches: EditServiceSubscriptionRequest[]) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/subscription/Company/Batch`;
    return this.httpClient.post<any[]>(url, batches);
  }

  displayServices(serviceIds: number[], serviceRows: any[]): string{
    const filteredRows = serviceRows.filter(sr => {
      return serviceIds.includes(sr.serviceTypeId)
    })
    let serviceToString = ''
    filteredRows.forEach(fr =>{
      if(serviceToString.length > 0){
        serviceToString += `, ${fr.serviceName}`;
      }else{
        serviceToString = fr.serviceName;
      }
    })
    return serviceToString;

  }

  displayFrequency(frequencyId: number, frequencyRows: any[]): string{
    const index = frequencyRows.findIndex(fr => fr.id == frequencyId)
    if(index != -1){
      return frequencyRows[index].frequencyName;
    }
    return "";
  }

  displayDay(dayNum, weekNum, frequencyId){
    let dayName = ""
    if(frequencyId == 4){
      switch(weekNum) {
        case 1: {
          dayName = 'Sunday';
          break;
        }
        case 2: {
          dayName = 'Monday';
          break;
        }
        case 3: {
          dayName = 'Tuesday';
          break;
        }
        case 4: {
          dayName = 'Wednesday';
          break;
        }
        case 5: {
          dayName = 'Thursday';
          break;
        }
        case 6: {
          dayName = 'Friday';
          break;
        }
        case 7: {
          dayName = 'Saturday';
          break;
        }
        default: {
          break;
        }
      }
    }else{
      dayName += `${dayNum}`;
      switch(dayNum) {
        case 1: {
          dayName += 'st';
          break;
        }
        case 2: {
          dayName += 'nd';
          break;
        }
        case 3: {
          dayName += 'rd';
          break;
        }
        default: {
          dayName += 'th';
          break;
        }
      }
    }
    return dayName;
  }
  displayMonth(monthNum: number): string{
    let monthName = ""
    switch(monthNum) {
      case 1: {
        monthName = 'January';
        break;
      }
      case 2: {
        monthName = 'February';
         break;
      }
      case 3: {
        monthName = 'March';
         break;
      }
      case 4: {
        monthName = 'April';
         break;
      }
      case 5: {
        monthName = 'May';
         break;
      }
      case 6: {
        monthName = 'June';
         break;
      }
      case 7: {
        monthName = 'July';
         break;
      }
      case 8: {
        monthName = 'August';
         break;
      }
      case 9: {
        monthName = 'September';
         break;
      }
      case 10: {
        monthName = 'October';
         break;
      }
      case 11: {
        monthName = 'November';
         break;
      }
      case 12: {
        monthName = 'December';
         break;
      }
      default: {
         break;
      }
   }
   return monthName
  }



}


// WEBPACK FOOTER //
// ./src/app/fleet-manager/company/components/companydetails/options/company-services-options/service-subscription.service.ts